<template>
  <div>
    <v-dialog
      v-model="dialog"
      width="1600"
      content-class="main_dialog"
      scrollable
      persistent
    >
      <v-card>
        <v-card-title
          style="font-size: 20px; color: #363636; border: 1px solid #c0c0c0"
          class="pb-4"
        >
          <div>
            <v-icon class="mr-1" style="padding-bottom: 3px"
              >mdi-plus-box-outline</v-icon
            >
            {{ $t("addannouncement") }}
          </div>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="cancelAdd()"
            color="#424242"
            style="border-radius: 8px !important"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="height: 600px">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row class="mt-5">
              <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                <v-row>
                  <v-col cols="6" xs="12" sm="12" md="6" lg="10">
                    <p style="color: #424242; font-size: 16px">
                      {{ $t("createdateM") }}
                      <span style="margin-right: 20px"></span>
                      {{ this.createdate }} {{ "By Admin" }}
                    </p>
                  </v-col>
                  <v-col cols="12">
                    <label for="title" class="font-style">
                      {{ $t("articletitle") }}
                      <span style="color: red">*</span>
                    </label>
                    <v-text-field
                      :rules="titleRules"
                      outlined
                      dense
                      hide-details
                      v-model="title"
                      class="rounded-lg"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" style="padding-top: 0; margin-top: 20px">
                    <label for="description" class="font-style">{{
                      $t("description")
                    }}</label>
                    <v-text-field
                      outlined
                      dense
                      hide-details
                      v-model="description"
                      class="rounded-lg"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="4" style="margin-top: 0px">
                    <label
                      style="font-size: 16px; color: #47484b; margin-top: 5px"
                      >{{ $t("startdatetime") }}</label
                    >
                    <v-menu
                      v-model="tomenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="todate"
                          append-icon="mdi-calendar-blank-outline"
                          outlined
                          dense
                          placeholder="yyyy/mm/dd"
                          readonly
                          hide-details
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="todate"
                        :allowed-dates="allowedStartDates"
                        @input="startdateDis()"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" lg="2" style="margin-top: 35px">
                    <v-menu
                      ref="menu"
                      v-model="totimemenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="time"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="totime"
                          :rules="toTimeRules"
                          append-icon="mdi-clock-outline"
                          hide-details
                          outlined
                          readonly
                          dense
                          v-bind="attrs"
                          v-on="on"
                          @click="totimemenu = true"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        ampm-in-title
                        v-if="totimemenu"
                        v-model="totime"
                        full-width
                        @click:minute="selectTime"
                      ></v-time-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" lg="4" style="margin-top: 0px">
                    <label
                      style="font-size: 16px; color: #47484b; margin-top: 5px"
                      >{{ $t("enddatetime") }}</label
                    >
                    <v-menu
                      v-model="endmenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="enddate"
                          append-icon="mdi-calendar-blank-outline"
                          outlined
                          dense
                          placeholder="yyyy/mm/dd"
                          readonly
                          hide-details
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="enddate"
                        @input="endmenu = false"
                        :allowed-dates="endallowedDates"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" lg="2" style="margin-top: 35px">
                    <v-menu
                      ref="menu"
                      v-model="endtimemenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="time"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="endtime"
                          :rules="endTimeRules"
                          append-icon="mdi-clock-time-four-outline"
                          outlined
                          readonly
                          dense
                          hide-details
                          v-bind="attrs"
                          v-on="on"
                          @click="endtimemenu = true"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        ampm-in-title
                        v-if="endtimemenu"
                        v-model="endtime"
                        full-width
                        @click:minute="$refs.menu.save(endtime)"
                      ></v-time-picker>
                    </v-menu>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                    lg="12"
                    style="padding-top: 0; margin-top: 20px"
                  >
                    <label for="link" class="font-style">{{
                      $t("linkurl")
                    }}</label>
                    <v-text-field
                      outlined
                      dense
                      hide-details
                      @input="checkLinkType"
                      v-model="linkUrl"
                      class="rounded-lg"
                    ></v-text-field>
                    <span v-if="notLink" style="color: red; font-size: 13px">{{
                      $t("invalidUrlLink")
                    }}</span>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                    lg="12"
                    style="padding-top: 0; margin-top: 20px"
                  >
                    <label for="description" class="font-style">{{
                      $t("showannouncement")
                    }}</label>
                    <div class="checkannouncement">
                      <v-row>
                        <v-checkbox
                          v-model="Cweb"
                          label="Customer Web"
                          hide-details
                          class="checkbox-spacing"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="Uview"
                          label="User view"
                          hide-details
                          class="checkbox-spacing"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="Mcheck"
                          label="Mobile"
                          hide-details
                          class="checkbox-spacing"
                        ></v-checkbox>
                      </v-row>
                    </div>
                  </v-col>
                  <v-progress-circular
                    v-if="loading"
                    indeterminate
                    class="loading-circle"
                    color="green"
                  ></v-progress-circular>
                </v-row>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                <v-row>
                  <v-col class="pt-0 pr-0 pb-0">
                    <v-radio-group
                      row
                      v-model="status"
                      class="mt-0"
                      hide-details
                    >
                      <v-radio
                        :label="'active'"
                        value="1"
                        color="#67AB30"
                      ></v-radio>
                      <v-radio
                        :label="'inactive'"
                        value="0"
                        color="#67AB30"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 2rem">
                  <v-col cols="12" xs="12" sm="12" md="6" lg="7" class="pt-0">
                    <p
                      class="text-left font-style mb-1"
                      :style="fileError ? { color: 'red' } : {}"
                    >
                      {{ $t("imagecover") }}
                    </p>
                    <div>
                      <v-card
                        width="100%"
                        :height="file != null ? 'auto' : '400'"
                        style="
                          border: 4px dashed #c0c0c0;
                          box-shadow: unset;
                          background: #f8f8f8 0% 0% no-repeat padding-box;
                          margin-top: 0.5rem;
                        "
                        @click="$refs.file.click()"
                        @dragover.prevent
                        @dragenter.prevent
                        @drop.prevent="dropImg($event)"
                      >
                        <v-img
                          :src="file"
                          @click="$refs.file.click()"
                          @mouseover="
                            file
                              ? (showEditImgTool = true)
                              : (showEditImgTool = false)
                          "
                          @mouseleave="
                            file
                              ? (showEditImgTool = false)
                              : (showEditImgTool = false)
                          "
                          :style="
                            fileError ? { border: '1px solid #FA5252' } : {}
                          "
                          width="100%"
                          height="auto"
                          style="
                            border-radius: 8px !important;
                            object-fit: contain;
                            background-size: contain !important;
                          "
                          class="mx-auto my-auto center"
                          v-if="file"
                        >
                          <v-card-title
                            v-if="showEditImgTool"
                            style="left: 15%; top: 15%; position: absolute"
                          >
                            <v-list
                              class="d-flex flex-column align-start"
                              style="padding: 0; border-radius: 8px"
                            >
                              <v-list-item class="list-item-padding">
                                <v-btn
                                  color="#424242"
                                  style="font-size: 14px; width: 100px"
                                  text
                                  class="text-capitalize"
                                  @click.stop="previewimg = true"
                                >
                                  <v-icon left>mdi-eye-outline</v-icon>
                                  {{ $t("preview") }}
                                </v-btn>
                              </v-list-item>

                              <v-list-item class="list-item-padding">
                                <v-btn
                                  color="error"
                                  style="font-size: 14px; width: 100px"
                                  text
                                  class="text-capitalize"
                                  @click.stop="file = null"
                                >
                                  <v-icon left>mdi-delete-outline</v-icon>
                                  {{ $t("delete") }}
                                </v-btn>
                              </v-list-item>
                            </v-list>
                          </v-card-title>
                        </v-img>

                        <v-img
                          v-if="!file"
                          src="@/assets/imgs/image_loader.png"
                          width="64"
                          height="52"
                          class="mx-auto center"
                          style="margin-top: 8.5rem"
                          @click="$refs.file.click()"
                        ></v-img>
                        <input
                          type="file"
                          class="d-none"
                          ref="file"
                          accept="image/*"
                          @change="uploadImg($event, 1)"
                        />
                        <p
                          v-show="!file"
                          class="text-center mt-3"
                          style="
                            color: #424242;
                            font-size: 14px;
                            opacity: 0.6;
                            margin-bottom: 0;
                          "
                        >
                          {{ $t("dragdropfile") }}
                        </p>
                        <p
                          v-show="!file"
                          class="text-center"
                          style="color: #424242; font-size: 14px; opacity: 0.6"
                        >
                          {{ $t("orbrowsefile") }} JPG"
                        </p>
                      </v-card>
                    </div>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="6" lg="5">
                    <v-row>
                      <v-btn
                        color="#A6CC39"
                        style="
                          font-size: 16px;
                          margin-top: 3rem;
                          float: left;
                          border-radius: 8px;
                          height: 40px;
                          width: 165px;
                        "
                        class="text-capitalize white--text btn_hover_effect"
                        @click="$refs.file.click()"
                      >
                        <v-icon class="mr-1">mdi-plus-box-outline</v-icon>
                        {{ $t("addcover") }}
                      </v-btn>
                    </v-row>
                    <v-row>
                      <p class="mt-3" style="color: #777777; font-size: 14px">
                        <span style="font-size: 14px;color:black">
                          {{ $t("recommendformatpng_announcement") }}</span
                        >
                        {{ $t("format") }}<br />
                        <span style="font-size: 14px;color:black">
                          {{ $t("resolution") }}
                        </span>
                        {{ $t("resolutionsize") }}
                      </p>
                      <p class="mt-3" style="color: #777777; font-size: 14px">
                        {{ $t("announcementdescription") }}
                      </p>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions class="mt-3 pb-4">
          <v-spacer></v-spacer>
          <v-btn
            class="text-capitalize btnfont-style"
            text
            @click="cancelAdd()"
            style="
              border: 1px solid #c0c0c0;
              border-radius: 8px;
              color: #424242;
            "
            >{{ $t("cancel") }}</v-btn
          >
          <v-btn
            class="text-capitalize btnfont-style btn_hover_effect"
            style="color: #ffff; border: 1px solid #a6cc39; border-radius: 8px"
            color="#A6CC39"
            width="100"
            @click="submit()"
            >{{ $t("submit") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- cropimage -->
    <v-dialog
      v-model="dialogCrop"
      width="550px"
      height="800px"
      overflow="hidden"
      scrollable
    >
      <v-card class="rounded-lg" overflow="hidden" height="800px">
        <v-card-title
          class="white--text pb-4"
          style="background-color: #a6cc39; font-size: 30px"
          >Crop Image</v-card-title
        >
        <v-card-text
          class="pt-12"
          style="height: 550px; padding-left: 4rem; padding-right: 4rem"
        >
          <vue-cropper
            ref="cropper"
            :img="option.img"
            :output-size="option.size"
            :output-type="option.outputType"
            :info="true"
            :full="option.full"
            :can-move="option.canMove"
            :can-move-box="option.canMoveBox"
            :fixed-box="option.fixedBox"
            :original="option.original"
            :auto-crop="option.autoCrop"
            :auto-crop-width="option.autoCropWidth"
            :auto-crop-height="option.autoCropHeight"
            :center-box="option.centerBox"
            :high="option.high"
          ></vue-cropper>
        </v-card-text>
        <v-card-actions class="mt-3 pb-4" style="margin-right: 50px">
          <v-spacer></v-spacer>

          <v-btn
            class="text-capitalize font-style"
            style="
              border: 1px solid #c0c0c0;
              border-radius: 8px;
              color: #424242;
            "
            text
            @click="CancelCrop()"
            >{{ $t("cancel") }}</v-btn
          >
          <v-btn
            class="text-capitalize btnfont-style btn_hover_effect"
            style="color: #ffff; border: 1px solid #a6cc39; border-radius: 8px"
            color="#A6CC39"
            @click="CropImage()"
            width="100"
            >{{ $t("submit") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- preview image -->
    <v-dialog
      v-model="previewimg"
      persistent
      width="450px"
      height="800px"
      overflow="hidden"
      content-class="elevation-0 preview_class"
    >
      <v-card overflow="hidden" color="transparent">
        <v-card-title style="padding-right: 0 !important">
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="previewimg = false"
            color="#FFFFFF"
            style="border-radius: 8px !important; border: 1px solid #ffffff30"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-img
          width="800px"
          height="500px"
          style="border-radius: 8px; margin: auto"
          :src="file"
        ></v-img>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { VueCropper } from "vue-cropper";
import * as moment from "moment/moment";
import enurl from "@/api/environment";
import axios from "axios";

export default {
  components: {
    VueCropper
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    full_name: String
  },
  watch: {
    file: function() {
      this.fileError = false;
    }
  },
  computed: {
    ...mapGetters(["editLibraryData"]),
    dialog: {
      get() {
        return this.show;
      },
      set() {
        this.$emit("close");
      }
    },
    endTimeRules() {
      return [v => !!v || "Specify end time"];
    },
    toTimeRules() {
      return [v => !!v || "Specify end time"];
    },
    titleRules() {
      return [v => !!v || "Title is required"];
    },
    wordContentRules() {
      return [v => !!v || "Word Content is required"];
    },
    isLink() {
      const urlRegex = /^(https?:\/\/(www\.)|(www\.))|(ftp|http(s)?:\/\/).+$/;
      return urlRegex.test(this.linkUrl);
    }
  },
  data: () => ({
    url: enurl.apiUrl,
    notLink: false,
    startdate: "",
    previewimg: false,
    time: false,
    enddate: new Date().toISOString().substr(0, 10),
    todate: new Date().toISOString().substr(0, 10),
    createdate: moment(new Date().toISOString().substr(0, 10))
      .local()
      .format("DD MMM YYYY"),
    showEditImgTool: false,
    valid: true,
    loading: false,
    dialogCrop: false,
    page: 1,
    pageCount: 0,
    totime: null,
    endtime: null,
    totimemenu: false,
    endtimemenu: false,
    tomenu: false,
    endmenu: false,
    item: [],
    Cweb: false,
    Uview: false,
    Mcheck: false,
    linkUrl: "",
    userpage: 1,
    userpageCount: 0,
    deptpage: 1,
    deptpageCount: 0,
    link: null,
    title: "",
    description: null,
    file: null,
    fileName: "",
    fileUrl: "",
    status: "1",
    option: {
      img: "",
      size: 1,
      full: false,
      outputType: "png",
      canMove: true,
      fixedBox: true,
      original: false,
      canMoveBox: false,
      autoCrop: true,
      autoCropWidth: 400,
      autoCropHeight: 587,
      centerBox: false,
      high: true
    },
    fileError: false
  }),
  mounted() {},
  methods: {
    setFileNull() {
      console.log("Call from parent....");
      this.file = null;
    },
    allowedStartDates: val => val >= new Date().toISOString().substr(0, 10),
    startdateDis() {
      let that = this;
      that.tomenu = false;
      if (that.todate > that.enddate) {
        that.enddate = that.todate;
      }
    },
    checkLinkType() {
      if (this.isLink || this.linkUrl === "") {
        this.notLink = false;
      } else {
        this.notLink = true;
      }
    },

    dropImg(e) {
      let file = e.dataTransfer.files[0];
      if (!/(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(file.name)) {
        alert("Please choose image!");
        return false;
      }
      this.fileName = file.name;
      let reader = new FileReader();
      reader.onload = f => {
        let src;
        if (typeof f.target.result === "object") {
          src = window.URL.createObjectURL(new Blob([f.target.result]));
        } else {
          src = f.target.result;
        }
        this.option.img = src;
        this.dialogCrop = true;
      };
      reader.readAsArrayBuffer(file);
    },

    uploadImg(e, num) {
      let self = this;
      let file = e.target.files[0];
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        alert("Please choose image!");
        return false;
      }
      this.fileName = file.name;
      let reader = new FileReader();
      reader.onload = e => {
        let data;
        if (typeof e.target.result === "object") {
          data = window.URL.createObjectURL(new Blob([e.target.result]));
        } else {
          data = e.target.result;
        }
        if (num === 1) {
          if (file.type === "image/gif") {
            // If it's a GIF file, do nothing (dialog is not opened)

            const reader = new FileReader();

            reader.onload = function(event) {
              const base64Data = event.target.result; // This is the base64 representation

              // Call your function and pass the base64 data as a parameter
              self.getFile(base64Data);
            };

            reader.readAsDataURL(file);
          } else {
            self.option.img = data;
            self.dialogCrop = true;
          }
        } else if (num === 2) {
          console.log("something wrong.");
        }
      };
      reader.readAsArrayBuffer(file);
    },

    CancelCrop() {
      this.dialogCrop = false;
    },
    CropImage() {
      this.$refs.cropper.getCropData(data => {
        this.getFile(data);
        this.dialogCrop = false;
      });
    },
    endallowedDates(val) {
      return val >= this.todate;
    },

    getFile(e) {
      this.fileUrl = e;
      this.file = e;
      this.showEditImgTool = false;
    },

    selectTime() {
      this.totimemenu = false;
    },
    newformatDate(newdate) {
      const newdate1 = newdate.split("T");
      const newtime = newdate1[1].split(":");
      const [year, month, day] = newdate1[0].split("-");
      const returndate =
        `${day}/${month}/${year}` + " " + newtime[0] + ":" + newtime[1] + ":00";
      return returndate;
    },
    async submit() {
      let self = this;
      if (self.$refs.form.validate() && self.notLink === false) {
        self.loading = true;
        console.log("file ", self.file);
        console.log("file name ", self.fileName);

        if (self.file) {
          const base64Res = await axios.post(
            `${self.url}File/UploadFileStringBase`,
            {
              base64: self.file,
              fileName: self.fileName
            }
          );
          console.log(base64Res);

          const startdata = new Date(self.todate + "T" + self.totime + ":00");
          const startisodata = startdata.toISOString();

          const enddata = new Date(self.enddate + "T" + self.endtime + ":00");
          const endisodata = enddata.toISOString();
          const data = {
            status: self.status == 1 ? true : false,
            title: self.title,
            description: self.description,
            startDate: self.todate,
            startTime: self.newformatDate(startisodata),
            endDate: self.enddate,
            endTime: self.newformatDate(endisodata),
            orgImage: base64Res.data,
            customerWebFlag: self.Cweb,
            userViewFlag: self.Uview,
            mobileFlag: self.Mcheck,
            linkURL: self.linkUrl
          };
          await axios
            .post(`${self.url}Announcement/AddAnnouncement`, data)
            .then(function(res) {
              if (res.data.status == 0) {
                self.cancelAdd();
                self.$emit("confirm");
                self.$refs.form.resetValidation();
                self.fileError = false;
              } else {
                alert(res.message);
              }
              self.dialog = false;
            })
            .catch(function(err) {
              alert(err);
              self.dialog = false;
            });
        } else {
          self.fileError = true;
          alert("Please attach a picture!");
        }
      } else {
        alert("Incomplete information. Please enter again!");
        self.fileError = true;
      }

      self.loading = false;
    },
    async GetAnnouncement() {
      let self = this;
      self.loading = true;
      axios
        .get(`${self.url}Announcement/GetAllAnnouncement`)
        .then(function(response) {
          self.announcementItems = response.data.data.map((v, i) => ({
            ...v,
            no: i + 1,
            createDate: moment(v.createDate)
              .local()
              .format("DD/MM/YYYY"),
            startDate: moment(v.startDate)
              .local()
              .format("DD/MM/YYYY"),
            startTime: moment(v.startTime)
              .local()
              .format("  LT")
          }));
          self.loading = false;
        })
        .catch(function(error) {});
    },
    // async addAnnouncement() {},
    cancelAdd() {
      this.$emit("close");
      this.$refs.form.resetValidation();
      this.$refs.file.value = null;
      this.fileError = false;
      this.title = "";
      this.description = "";
      this.todate = "";
      this.totime = "";
      this.endtime = "";
      this.tomenu = false;
      this.endmenu = false;
      this.totimemenu = false;
      this.endtimemenu = false;
      this.status = "1";
      this.Cweb = false;
      this.Uview = false;
      this.Mcheck = false;
      this.linkUrl = "";
      this.file = "";
    }
  }
};
</script>
<style scoped>
.checkbox-spacing {
  margin-top: 0px;
  margin-right: 30px; /* Adjust the margin as per your preference */
}
.checkannouncement {
  position: absolute;
  left: 37px;
  font-weight: bold;
}
.loading-circle {
  position: fixed;
  z-index: 5;
  right: 50%;
  bottom: 50%;
  transform: translate(-50%, -50%);
}
.textannouncement {
  position: relative;
  bottom: 25px;
  left: 15px;
  font-weight: bold;
}
::v-deep .v-dialog {
  border-radius: 18px !important; /**35px */
}
::v-deep .preview_class.v-dialog {
  border-radius: 8px !important;
}
::v-deep .v-text-field__slot {
  font-size: 16px !important;
}
.btnfont-style {
  font-size: 20px;
}
.font-style {
  font-size: 16px;
  color: #424242;
}
::v-deep .v-input__slot {
  border-radius: 10px !important;
}
::v-deep .article-table tr:nth-child(even) {
  background: unset;
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  font-size: 17px !important;
  color: #47484b !important;
  background-color: #e0e0e0 !important;
  opacity: 1;
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td {
  font-size: 16px !important;
  color: #47484b !important;
  opacity: 1;
}
::v-deep .accent {
  background-color: #a6cc39 !important;
}
::v-deep .v-tab--active {
  background-color: #a6cc39 !important;
  color: #ffffff !important;
}
::v-deep .v-simple-checkbox .mdi-checkbox-blank-outline {
  color: #c0c0c0 !important;
}
::v-deep .v-simple-checkbox .mdi-checkbox-marked {
  color: #a6cc39 !important;
}
::v-deep .v-simple-checkbox .mdi-minus-box {
  color: #a6cc39 !important;
}
::v-deep .pagination .primary {
  background-color: #a6cc39 !important;
  color: #ffffff !important;
  /* opacity: 1; */
}
.v-application .primary--text {
  color: #aecb53 !important;
  caret-color: #aecb53 !important;
}
::v-deep .primary--text {
  color: #a6cc39 !important;
}
::v-deep .primary {
  background-color: #a6cc39 !important;
  border-color: #a6cc39 !important;
}
::v-deep .accent--text {
  color: #a6cc39 !important;
  caret-color: #a6cc39 !important;
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>

<style scoped>
.list-item-padding.v-sheet.v-list {
  border-radius: 8px !important;
}
.list-item-padding.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover {
  border-radius: 8px !important;
}
.list-item-padding.list-item-padding.theme--light {
  padding: 0 5px !important;
  min-height: 42px !important;
}

::v-deep .v-data-table thead th:first-child {
  border-radius: 8px 0 0 8px;
} /**.child_table */
::v-deep .v-data-table thead th:last-child {
  border-radius: 0 8px 8px 0;
}
::v-deep .v-dialog {
  border-radius: 16px !important;
}
.dynamic-width-dialog {
  width: auto;
  max-width: 600px !important; /* Set a maximum width if needed */
  min-width: 200px !important; /* Set a minimum width if needed */
}
</style>

<style scoped>
::v-deep .main_dialog.v-dialog {
  max-height: 90% !important;
  height: 700px !important;
}
@media screen and (min-width: 1444px) {
  ::v-deep .main_dialog.v-dialog {
    max-height: 100% !important;
    height: 900px !important;
  }
}
</style>
